import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ReactComponent as NoJobDetails } from 'assets/images/Jobs/jobDetailsNotFound.svg';
import { AppLink } from 'components/common/Link/Link';
import { useHistory } from 'react-router-dom';
import { theme } from 'styles/theme';
import { useSmMediaQuery } from 'containers/MobileDesktopContainer/useMediaQuery';
import { useFeatureToggle } from 'components/FeatureToggle/useFeatureToggle';
import { FeatureToggles } from 'enums/featureToggles';
import { setActivePage } from 'store/slices/navigation/navigationSlice';
import { useAppDispatch } from 'store/configureStore';

export const NoJobDetailsSplash = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const isMobileDevice = useSmMediaQuery();
  const isACSJobSearch = useFeatureToggle(FeatureToggles.ENABLE_ACS_JOB_SEARCH);

  const handleClick = () => {
    history.push('/jobs');
  };

  useEffect(() => {
    dispatch(setActivePage('Job Not Found'));
  }, []);

  useEffect(() => {
    if (isACSJobSearch && isMobileDevice) {
      let header = document.getElementById('header');
      let footer = document.getElementById('site-footer');

      if (footer) {
        footer.style.display = 'none';
      }
      if (!header) return;
      header.style.display = 'none';
      return () => {
        if (header) {
          header.style.display = 'flex';
        }
        if (footer) {
          footer.style.display = 'flex';
        }
      };
    }
  }, [isACSJobSearch, isMobileDevice]);

  return (
    <Card
      sx={{
        padding: { sm: '24px', md: '48px' },
        margin: { xs: '0px 24px', md: '0px' },
        height: { xs: '500px', md: '480px' },
        display: 'flex',
        width: { sm: '100%', md: '555px' },
        borderRadius: '10px',
        boxShadow: {
          xs: `0px 1px 15px ${theme.palette.system.boxShadowGray}`,
        },
      }}
    >
      <Grid
        container
        justifyContent={{ xs: 'space-between', md: 'center' }}
        alignContent="center"
        flexWrap="nowrap"
        flexDirection={{ xs: 'column', md: 'row' }}
        sx={{ padding: { xs: '24px 60px', md: '0px' } }}
      >
        <Grid container item>
          <Grid item md={10.5} mt="auto" mb="auto" justifyContent="center">
            <Typography
              variant="h3"
              color="system.midnightBlue"
              lineHeight="24px"
            >
              <i>Uh oh!</i>
              <br />
              <i>Job Not Found.</i>
            </Typography>
            <Divider
              sx={{
                backgroundColor: theme.palette.system.skyBlue,
                borderWidth: '2px',
                margin: '12px 0 24px 0',
                width: '100px',
              }}
            />
            <Typography
              variant="subtitle1"
              color="system.grayText"
              lineHeight="24px"
            >
              The job may not be available anymore or the link is wrong. No
              worries, we have a ton of great jobs for you in{' '}
              <AppLink
                onClick={handleClick}
                component={'span'}
                linkStyles={{
                  cursor: 'pointer',
                  fontSize: '16px',
                  lineHeight: '24px',
                }}
              >
                Job Search
              </AppLink>
              !
            </Typography>
          </Grid>
        </Grid>
        <Grid item display="flex" justifyContent="flex-end" alignItems="center">
          <NoJobDetails />
        </Grid>
      </Grid>
    </Card>
  );
};
